module.exports = __webpack_public_path__ + "8b3fde564279b12880b7ee72d35ccea0.MP3";